import { useState, useMemo, useCallback } from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { useGetRetailListQuery } from '../../../../api/endpoints/parts';

const useRetailSales = () => {
    const { th } = useLanguage();
    const [customerType, setCustomerType] = useState(0);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: null,
        sortOrder: null
    });

    const { data, isFetching, refetch } = useGetRetailListQuery({
        PageNumber: lazyParams.page,
        PageSize: lazyParams.rows,
        CustomerType: customerType
    });

    const items = data?.items ?? [];
    const totalCount = data?.totalCount ?? 0;

    const onPage = useCallback((event) => {
        const calculatedPage = Math.floor(event.first / event.rows) + 1;
        setLazyParams((prev) => ({
            ...prev,
            first: event.first,
            rows: event.rows,
            page: calculatedPage
        }));
    }, []);

    const onSort = useCallback((event) => {
        setLazyParams((prev) => ({
            ...prev,
            sortField: event.sortField,
            sortOrder: event.sortOrder
        }));
    }, []);

    const handleCustomerTypeChange = useCallback((value) => {
        setCustomerType(value);
        setLazyParams((prev) => ({ ...prev, first: 0, page: 1 }));
    }, []);

    const sortedData = useMemo(() => {
        if (!lazyParams.sortField) return items;
        const order = lazyParams.sortOrder === 1 ? 1 : -1;
        return [...items].sort((a, b) => {
            const aVal = a[lazyParams.sortField] ?? '';
            const bVal = b[lazyParams.sortField] ?? '';
            return order * String(aVal).localeCompare(String(bVal), 'tr', { numeric: true });
        });
    }, [items, lazyParams.sortField, lazyParams.sortOrder]);

    return {
        customerType,
        setCustomerType: handleCustomerTypeChange,
        data: sortedData,
        totalCount,
        loading: isFetching,
        lazyParams,
        onPage,
        onSort,
        refetch
    };
};

export default useRetailSales;

